'use strict'

define ['./applicationDeleteModal.css'], () ->
  ($q, $scope, $rootScope, $uibModalInstance, Application, $cacheFactory, Flash) ->
    $scope.theme_color = $rootScope.THEME_COLOR
    
    $scope.remove_apps = () ->
      $scope.is_removing = true
      promises = []

      for bundle in $scope.bundles
        for app in bundle.applications
          promises.push(Application.delete({id: app.id}).$promise)
      
      $q.all(promises)
        .then () ->
          Flash.create('success', 'Applicant has been deleted.', 4000, {class: 'delete-success'}, true);
          $scope.is_removing = false
          $rootScope.$broadcast 'refresh-appbundle-table'
          $uibModalInstance.close()



// WEBPACK FOOTER //
// ./directives/applicationDeleteModal/applicationDeleteModal.coffee